import { Component } from '@angular/core';
import { ViewController, Events } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';

import { ApiProvider } from '../../providers/api/api';

@Component({
  selector: 'page-lingua',
  templateUrl: 'lingua.html',
})

export class LinguaPage {
    lng;
    cliente = 0;

	constructor(public viewCtrl: ViewController, public translate: TranslateService, private storage: Storage, public events: Events, private _api: ApiProvider) {
    	this.lng = this.translate.getDefaultLang();
    	if(this.lng != null)
    	{
    	    this.translate.use(this.lng);
        }

        this.storage.get('id_cliente').then((val) => {
            if(val != null)
                this.cliente = val;
        });
	}

	escolheLng(lng2)
	{
        if(this.cliente != 0)
            this._api.changeLanguage({id: this.cliente, lng2: lng2}).subscribe(arg1=>{});

        this.translate.setDefaultLang(lng2);
        
        setTimeout( () => {
            this.events.publish('change:lng');
        }, 100);
        
        this.translate.use(lng2);
        
        this.storage.set('lng', lng2);


    	this.viewCtrl.dismiss();
	}

    getClass(lng2)
    {
        if(lng2 == this.lng)
        {
            return 'ativo';
        }
        return '';
    }

}



// WEBPACK FOOTER //
// ./src/pages/lingua/lingua.ts